export enum ChatType {
  ChatTypeHuman = 'Human',
  ChatTypeAgent = 'Agent',
}
